// Static assets exported from the Figma "Free Trial Landing page" frame
// (Jen Esquer's team library, node 20191:9068).
import heroPhoto from '../../../static/images/freetrial/hero-photo.jpg';
import heroPhoneScreen from '../../../static/images/freetrial/hero-phone-screen.jpg';
import phoneFrame from '../../../static/images/freetrial/phone-frame.png';
import strengthPhoto from '../../../static/images/freetrial/strength-photo.jpg';
import strengthPhotoMobile from '../../../static/images/freetrial/strength-photo-mobile.jpg';
import timelinePhoneScreen from '../../../static/images/freetrial/timeline-phone-screen.jpg';
import stepsPhoneScreen from '../../../static/images/freetrial/steps-phone-screen.jpg';
import guidePhoto from '../../../static/images/freetrial/guide-photo.jpg';
import {
  arrowRight,
  badgeAppStore,
  badgeGooglePlay,
  ctaCircles,
  iconKettlebell,
  iconPain,
  iconSavings,
  iconTogether,
  phoneScreenMask,
  playButton,
  quote,
  star,
  timelineCircles,
} from './svgs';

export const FT_IMAGES = {
  heroPhoto,
  heroPhoneScreen,
  phoneFrame,
  phoneScreenMask,
  badgeAppStore,
  badgeGooglePlay,
  star,
  arrowRight,
  iconPain,
  iconSavings,
  iconKettlebell,
  iconTogether,
  strengthPhoto,
  strengthPhotoMobile,
  timelineCircles,
  timelinePhoneScreen,
  quote,
  // The video section in Figma uses the same photo as the hero.
  videoPoster: heroPhoto,
  playButton,
  stepsPhoneScreen,
  guidePhoto,
  ctaCircles,
};
